import experimentsConfig from '../../experiments.yaml';
export const getExperimentsConfig = () => {
  return experimentsConfig;
};